export default class Base {
  constructor(params) {
    this.isLoading = false;
    if (params) {
      for (const [key, value] of Object.entries(params)) {
        this[key] = value;
      }
    }
  }

  toggleIsLoading() {
    this.isLoading = !this.isLoading;
  }
}
